module.exports = __webpack_public_path__ + "static/media/iiitlogo.8a27ce18.png";